/**
 * Routes that render light regardless of the theme preference: pre-purchase funnels, payment
 * pages and shareable artefacts whose designs are light-only. Shared by the pre-paint script
 * (features/theme/init-script.ts) and the theme model, so the two never disagree.
 *
 * Prefix match on whole path segments: "/upsell" matches "/upsell/ai_tools" but not
 * "/upsell-preview", which is listed on its own.
 */
export const PINNED_LIGHT_PATH_PREFIXES: readonly string[] = [
    // (onboardings)
    "/onboarding",
    "/experiment",
    "/payment",
    // (app-onboarding)
    "/app-onboarding",
    // (learning-plan): pre-purchase plan screen
    "/learning-plan",
    "/subscription-update",
    // Marketing landings with their own payment flows.
    "/creator",
    "/luck",
    // Printable / shareable certificate page.
    "/certificate"
];

/**
 * Sub-paths of a pinned prefix that are themed after all: post-purchase screens that render in
 * the app shell for a signed-in user (the renew success page lives under /payment).
 */
export const PINNED_LIGHT_PATH_EXCEPTIONS: readonly string[] = ["/payment/renew-success"];

const matchesPrefix = (pathname: string, prefix: string) => pathname === prefix || pathname.startsWith(`${prefix}/`);

export const isPinnedLightPath = (pathname: string): boolean =>
    !PINNED_LIGHT_PATH_EXCEPTIONS.some((prefix) => matchesPrefix(pathname, prefix)) &&
    PINNED_LIGHT_PATH_PREFIXES.some((prefix) => matchesPrefix(pathname, prefix));
